import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { SiteCountry } from '../../data/models/locale'
import {
  absoluteRedirects,
  redirects as manualRedirects,
} from '../../redirects'
import { redirects as discountRedirects } from '../../urls/discountRedirects'

export function getRedirects(country: SiteCountry) {
  const redirects = manualRedirects.concat(discountRedirects)
  return redirects
    .filter(r => r.urls[country] !== null)
    .map(r => {
      const to = `/${country}${r.urls[country] || r.urls.default}`
      return <Redirect key={r.path} from={r.path} to={to} />
    })
    .concat(
      Object.entries(absoluteRedirects).map(([from, to]) => (
        <Redirect key={from} from={from} to={to} />
      )),
    )
}
